
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    iconAllTitle: [],
  }),
  computed: {
    iconTitle() {
      return this.label
        .split(' ')
        .join('_')
        .replace(/\//g, '-')
        .replace("'", '')
        .toLowerCase()
    },
    hasIcon() {
      if (this.iconTitle.search('number_of_rooms') !== -1) {
        return 'warehouse'
      }
      if (this.iconTitle.search('number_of_floors') !== -1) {
        return 'number_of_floors_-_over_10'
      } else {
        return this.iconAllTitle.includes(this.iconTitle)
          ? this.iconTitle
          : 'check'
      }
    },
  },
}
